import React from "react";
import { Link } from 'react-router-dom';

import { withRouter } from "./react/WithRouter";

import DataTable from 'react-data-table-component';

import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import ListGroup from "react-bootstrap/ListGroup";
import Spinner from 'react-bootstrap/Spinner';
import Badge from 'react-bootstrap/Badge';

import { MultiSelect } from 'primereact/multiselect';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { OverlayPanel } from 'primereact/overlaypanel';

import { faEllipsisVertical, faPencil, faTrashCan, faTriangleExclamation, faFileDownload, faFilter, faPlusSquare} from "@fortawesome/free-solid-svg-icons";
import { faEye } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import RiskDialog from "./RiskDialog";
import RiskReportDialog from "./RiskReportDialog";

import { RiskLevels, ConsequenceLevels, ProbabilityLevels, RiskLevelsReduced } from './RiskLevels'

import update from 'immutability-helper';

import "../Layout.css";

class RiskList extends React.Component {
	riskScale = [1, 2, 3, 4, 5];

	probabilityScale = [{ id: 1, text: '1 Very unlikely' }, { id: 2, text: '2 Unlikely' }, { id: 3, text: '3 Possible' }, { id: 4, text: '4 Likely' }, { id: 5, text: '5 Very likely' }];
	consequenceScale = [{ id: 1, text: '1 Negligible' }, { id: 2, text: '2 Minor' }, { id: 3, text: '3 Moderate' }, { id: 4, text: '4 Significant' }, { id: 5, text: '5 Severe' }];

	state = {
		filterText: "",
		riskList: [],
		deleteRiskID: 0,
		modal: "",
		isModalLoading: false,
		isLoadingData: false,
		SelectedRisk: 0,
		selectedCategoryFilter: [],
		availableCategories:[],
		selectedAreaFilter: [],
		availableAreas: [],
		selectedRiskFilter: [],
	};

	constructor() {
		super()

		this.opRef = React.createRef(null);
		//this.expandList = [];
	}

	componentDidMount() {
		this.fetchRiskList();
	}

	fetchRiskList() {
		this.setState({ isLoadingData: true });
		fetch(`api/Risk/GetAllRisks`, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				if (data.error) {
					throw (data.error);
				}
				//Check which risks should have its mitigations expanded
				data.forEach(element => {
					const oldRisk = this.state.riskList.find(item => item.riskID === element.riskID);
					if (oldRisk) {
						element.isExpanded = (oldRisk.isExpanded || false);
					}
				});
				//console.log(data);
				this.filterLists(data);
				this.setState({ riskList: data });
				this.setState({ isLoadingData: false });
			})
			.catch(error => {
				this.setState({ isLoadingData: false });
			})
	}

	fetchDeleteRisk(riskID) {
		this.setState({ isLoadingData: true });
		fetch(`api/Risk/RemoveRisk/` + riskID, { method: 'DELETE', headers: { 'Content-Type': 'application/json' } })
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				if (data.error) {

					throw (data.error);
				}
				this.setState({ deleteFlowID: 0 });
				this.setState({ isLoadingData: false });
				this.fetchRiskList();
			})
			.catch(error => {
				//this.setState({ message: error });
				this.setState({ isLoadingData: false });
			})
	}

	deleteRisk(riskID) {
		this.setState({ deleteRiskID: riskID });
		const accept = this.fetchDeleteRisk.bind(this, riskID);
		const reject = () => { };
		const message = 'Do you really want to archive ' + this.state.riskList.find(item => item.riskID === riskID).name  + '?';

		confirmDialog({
			message: message,
			header: 'Archive Risk',
			icon: 'pi pi-info-circle',
			acceptClassName: 'p-button-danger',
			accept,
			reject
		});
	}

	filterLists(data) {
		const uniqueCat = data.map((risk) => risk.category).filter((item, i, ar) => ar.indexOf(item) === i).map((cat) => { return { name: cat } });
		this.setState({ availableCategories: uniqueCat });
		
		const uniquePro = data.map((risk) => risk.process).filter((item, i, ar) => ar.indexOf(item) === i).map((area) => { return { name: area } });		
		this.setState({ availableAreas: uniquePro });
	}

	menuPopup(row) {
		return (
			<Popover id="popover-basic" className="popup-menu shadow ">
				<Popover.Body>
					<ListGroup>
						{row.editorID === 0 ?
							<ListGroup.Item onClick={() => document.body.click()}>
								<Link to={'/Risk/' + row.riskID}>
									<FontAwesomeIcon icon={faEye} size="sm" /> View
								</Link>
							</ListGroup.Item>							
							:
							<ListGroup.Item onClick={() => document.body.click()}>
								<Link to={'/Risk/' + row.riskID}>
									<FontAwesomeIcon icon={faPencil} size="sm" /> Edit
								</Link>
							</ListGroup.Item>								
						}
						{false ? null :
							<ListGroup.Item onClick={() => { document.body.click(); this.deleteRisk(row.riskID) }} >
								<FontAwesomeIcon icon={faTrashCan} /> Archive
							</ListGroup.Item>
						}					
					</ListGroup>
				</Popover.Body>
			</Popover>
		);

	}
	
	customLoader() {
		return (
			<div style={{ padding: '24px' }}>
				<Spinner animation="border" />
				<div>Loading...</div>
			</div>
		);
	}

	displayOwner(workFlow) {
	/*	var owners = "";
		if (workFlow.editorID === 0) {
			owners = workFlow.ownerRoles.map(role => role.roleName).join(", ") || "";
		} else {
			owners = workFlow.editorName;
		}
		return owners;*/
	}


	riskTemplate(rowData) {	
		const level = RiskLevels[rowData.consequence - 1][rowData.probability - 1];
		const text = level.label;
		const riskBgColor = level.bgColor;
		const riskColor = level.color;
		const style = { backgroundColor: riskBgColor, color: riskColor, width:  "100%" };
		return (
			<Badge style={style} bg="" > { text }</ Badge>
		);
	}

	probabilityTemplate(rowData) {
		var text = this.probabilityScale.find(item => item.id === rowData.probability).text;
		return (
			<Badge style={{ width: "100%", border: "1px solid black" }} bg="white" text="dark">{text}</Badge>
		);
	}

	consequenceTemplate(rowData) {
		var text = this.consequenceScale.find(item => item.id === rowData.consequence).text;
		return (
			<Badge style={{ width: "100%", border: "1px solid black" }} bg="white" text="dark">{text}</Badge>
		);
	}

	activateDeleteModal(riskID) {
		//document.activeElement.blur()
		this.setState({ deleteRiskID: riskID });
		this.setState({ modal: "delete" });
	}

	activateEditModal(id) {
		this.setState({ selectedRisk: id });
		this.setState({ modal: 'riskdetails' });
	}

	activateNewModal() {
		this.setState({ selectedRisk: 0 });
		this.setState({ modal: 'riskdetails' });
	}

	handleCloseRiskReportDialog() {
		this.setState({ modal: '' });
	}

	handleCloseRiskDialog(hasNewData, riskID) {
		if (hasNewData) {
			this.props.navigate("/Risk/" + riskID);
		}
		this.setState({ selectedRisk: -1 });
		this.setState({ modal: '' });
	}

	handleExpandMitigations(event) {
		return (event.data.description);
	}

	handleToggleExpand(expanded, row) {
		const index = this.state.riskList.findIndex(obj => { return obj.riskID === row.riskID });
		const newRiskList = update(this.state.riskList, { [index]: { isExpanded: { $set: expanded } } });
		this.setState({ riskList: newRiskList });
	}

	handleIsExpanded(row) {
		var risk = this.state.riskList.find((obj) => obj.riskID === row.riskID).isExpanded || false;
		return risk;
	}

	filter() {
		return (
			<Popover id="popover-basic" className="popup-menu shadow ">
				<Popover.Body>
					<Card>
						<Card.Header>
						<b>Filter risks</b>
						</Card.Header>
						<Card.Body>
							<div className="p-field">
								<label className="p-field-label">Risk category</label>
								<MultiSelect
									value={this.state.selectedCategories}
									options={this.state.availableCategories}
									optionLabel="name"
									placeholder="Select role..."
									className="p-inputtext-sm w-full md:w-15rem"
									onChange={(e) => { }}
								/>
							</div>

							<div className="p-field">
								<label className="p-field-label">Area/Process</label>
								<MultiSelect
									value={this.state.selectedArea}
									options={this.state.availableAreas}
									optionLabel="name"
									placeholder="Select role..."
									className="p-inputtext-sm w-full md:w-15rem"
									display="chip"
									onChange={(e) => { }}
								/>
							</div>

						</Card.Body>
					</Card>
				</Popover.Body>
			</Popover>
		);
	}

	render() {
		//const filteredData = this.state.riskList;
		//const filteredData = this.state.availableCategories.filter(
		//	item => this.selectedCategories.length === 0  || this.selectedCategories.some(cat => cat.name === item.name),
		//);
		const filteredData = this.state.riskList.filter(
			(item => (this.state.selectedAreaFilter.length === 0 || this.state.selectedAreaFilter.some(area => item.process === area.name)) &&
				(this.state.selectedCategoryFilter.length === 0 || this.state.selectedCategoryFilter.some(area => item.category === area.name)) &&
				(this.state.selectedRiskFilter.length === 0 || this.state.selectedRiskFilter.some(level => RiskLevels[item.consequence - 1][item.probability - 1].label === level.name))
			)
		);
		

		const customStyles = {
			headRow: {
				style: {
					border: 'none',
				},
			},
			headCells: {
				style: {
					color: '#202124',
					fontSize: '14px',
				},
			},
			rows: {
				highlightOnHoverStyle: {
					backgroundColor: 'AliceBlue',
					borderBottomColor: '#FFFFFF',
					borderRadius: '25px',
					outline: '1px solid #FFFFFF',
				},
			},
		};
		
		const columns = [
			{
				cell: (row) => <FontAwesomeIcon icon={faTriangleExclamation} style={{ backgroundColor: RiskLevels[row.consequence - 1][row.probability - 1].bgColor, color: 'white', padding: '0.3rem 0.35rem', borderRadius: '5px' }} />,
				//cell: () => <FontAwesomeIcon icon={faTriangleExclamation} size="lg" />,
				width: '1.5rem', // custom width for icon button
				style: {
					borderBottom: '1px solid #FFFFFF',
					marginBottom: '-1px',
				},
			},
			{
				name: 'Risk name',
				selector: row => row.name,
				sortable: true,
				grow: 0.25,
				style: {
					color: '#202124',
					fontSize: '14px',
					fontWeight: 500,
				},
			},
			{
				name: 'Category',
				selector: row => row.category,
				sortable: true,
				grow: 0.25,
				style: {
					color: 'rgba(0,0,0,.54)',
				},
			},
			{
				name: 'Area/Process',
				selector: row => row.process,
				sortable: true,
				grow: 0.25,
				style: {
					color: 'rgba(0,0,0,.54)',
				},
			},
			{
				name: 'Risk',
				selector: row => row.consequence * row.probability,
				cell: row => this.riskTemplate(row),
				sortable: true,
				width: '8rem',
				style: {
					color: 'rgba(0,0,0,.54)',
				},
			}, 
			{
				name: 'Owner',
				selector: row => row.ownerName,
				sortable: true,
				grow: 0.25,
				style: {
					color: 'rgba(0,0,0,.54)',
				},
			},
			{
				cell: row => <OverlayTrigger trigger="click" rootClose placement='left' overlay={this.menuPopup(row)}>
					<Button variant="light" className="btn-circle"><FontAwesomeIcon icon={faEllipsisVertical} /></Button>
				</OverlayTrigger>,
				allowOverflow: true,
				button: true,
				width: '3rem',
			},
		];

		return (
			<Card className="workspace-card">

				<ConfirmDialog />
				<RiskDialog visible={this.state.modal === 'riskdetails'} onClose={this.handleCloseRiskDialog.bind(this)} riskID={this.state.selectedRisk} />
				<RiskReportDialog visible={this.state.modal === 'riskReport'} onClose={this.handleCloseRiskReportDialog.bind(this)} riskList={filteredData.map(r => r.riskID) } />

				{/*this.state.modal === 'delete' ? this.modalDelete():null*/}
				<Card.Header>
					<div style={{ float: 'left' }}>
						<b>Risks</b>
					</div>
					<div style={{ float: 'right' }}>
						{/* */}
						<Button size='sm' id={"btn_filter"} variant="secondary" onClick={(e) => this.opRef.current.toggle(e)}><FontAwesomeIcon icon={faFilter} /></Button>
						<Button size='sm' id={"btn_filter"} variant="secondary" onClick={(e) => this.setState({modal:'riskReport'})} style={{ marginLeft: '0.5rem' }}><FontAwesomeIcon icon={faFileDownload} /> Risk report</Button>
						<OverlayPanel ref={this.opRef} >
							<div className="p-field" style={{ marginBottom:'1rem' }}>							
								<MultiSelect
									value={this.state.selectedCategoryFilter}
									options={this.state.availableCategories}
									optionLabel="name"
									placeholder="Select category"
									className="p-inputtext-sm w-full md:w-15rem"
									
									onChange={(e) => { this.setState({ selectedCategoryFilter: e.value }) }}
								/>
							</div>

							<div className="p-field" style={{ marginBottom:'1rem' }}>								
								<MultiSelect
									value={this.state.selectedAreaFilter}
									options={this.state.availableAreas}
									optionLabel="name"
									placeholder="Select area/process"
									className="p-inputtext-sm w-full md:w-15rem"
								
									onChange={(e) => { this.setState({ selectedAreaFilter: e.value }) }}
								/>
							</div>

							<div className="p-field">
								<MultiSelect
									value={this.state.selectedRiskFilter}
									options={RiskLevelsReduced}
									optionLabel="name"
									placeholder="Select risk level"
									className="p-inputtext-sm w-full md:w-15rem"
									display="chip"
									onChange={(e) => { this.setState({ selectedRiskFilter: e.value }) }}
								/>
							</div>
						</OverlayPanel>

						<Button size='sm' onClick={() => { this.activateNewModal() }} id={"btn_add"} variant="primary" disabled={false} style={ {marginLeft:'0.5rem'} }><FontAwesomeIcon icon={faPlusSquare} /> New </Button>
					</div>
				</Card.Header>
				<Card.Body style={{ overflowX: 'auto', overflowY: 'auto', width: '100%', height: '100%', display: 'grid', margin: 0, padding: 0, whiteSpace: 'nowrap'}}>
						<DataTable		
							responsive
							className="data-table"
							columns={columns}
							data={filteredData}
							customStyles={customStyles}
							progressPending={this.state.isLoadingData}
							progressComponent={this.customLoader()}
							highlightOnHover
							pointerOnHover
							noHeader={true}				
							onRowClicked={(row, event) => this.props.navigate("/Risk/" + row.riskID)}
							/>
					
				</Card.Body>
			</Card >
		)
	}
}
export default withRouter(RiskList);

/*expandableRows
expandableIcon={{ collapsed: <FontAwesomeIcon icon={faChevronRight} className="chevron-close" />, expanded: <FontAwesomeIcon icon={faChevronRight} className="chevron-open" /> }}
expandableRowsComponent={this.handleExpandMitigations.bind(this)}
expandableRowExpanded={this.handleIsExpanded.bind(this)}
onRowExpandToggled={this.handleToggleExpand.bind(this)}*/